/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {CollectionFactory, Reducer} from '@modifi/redux'
import {FileInfoView, getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {AppThunkAction} from '../../types/redux'
import {removeForeignKeyFromId} from './utils'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = CollectionFactory({
  actionNamePrefix: 'data/seller-trade-partners/documents',
  reducerPath: ['data', 'sellerTradePartners', 'documents'],
  entityPrimaryKeySelector: (entity: FileInfoView) => entity.fileId!,
  // @ts-expect-error wrong typing in @modifi/redux
  fetchRequest: (state, params: {externalPartnerCompanyId: string}) =>
    apiClient.TradePartners.documents({
      externalBuyerTradePartnerId: params.externalPartnerCompanyId,
    }).then(res => res.data()?.files || []),
})

export default reducer as Reducer

export const selectSellerTradePartnerDocumentsByTradePartnerId = (
  state: Record<string, any>,
  externalPartnerCompanyId: string
): FileInfoView[] =>
  selectors.selectByKeyWindow(state, {
    externalPartnerCompanyId: removeForeignKeyFromId(externalPartnerCompanyId),
  })

const selectSellerTradePartnerDocumentsFetchCountByTradePartnerId = (
  state: Record<string, any>,
  externalPartnerCompanyId: string
): number => selectors.selectFetchCountByKeyWindow(state, {externalPartnerCompanyId})

const selectSellerTradePartnerDocumentsAreLoadingByTradePartnerId = (
  state: Record<string, any>,
  externalPartnerCompanyId: string
): boolean => selectors.selectIsKeyWindowLoading(state, {externalPartnerCompanyId})

export const aFetchSellerTradePartnerDocumentsByTradePartnerId = (
  externalPartnerCompanyId: string
): any =>
  actions!.fetch({
    externalPartnerCompanyId: removeForeignKeyFromId(externalPartnerCompanyId),
  })

export const aEnsureSellerTradePartnerDocumentsByTradePartnerId =
  (externalPartnerCompanyId: string): AppThunkAction<void> =>
  (dispatch, getState): void => {
    if (
      selectSellerTradePartnerDocumentsAreLoadingByTradePartnerId(
        getState(),
        externalPartnerCompanyId
      ) ||
      selectSellerTradePartnerDocumentsFetchCountByTradePartnerId(
        getState(),
        externalPartnerCompanyId
      ) > 0
    ) {
      return
    }
    dispatch(aFetchSellerTradePartnerDocumentsByTradePartnerId(externalPartnerCompanyId))
  }
